import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('./schedules/schedules.routes').then((m) => m.schedulesRoutes)
  }
];
